(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairGeneralInformationController', PhysicalFairGeneralInformationController);
        PhysicalFairGeneralInformationController.$inject = ['ExpoService', 'isPrivate', 'expos', 'CitiesByExpoService', '$uibModal'];
    function PhysicalFairGeneralInformationController(ExpoService, isPrivate, expos, CitiesByExpoService) {
        var vm = this;

        vm.selectExpos                      = selectExpos;
        vm.selectCitiesByExpo               = selectCitiesByExpo;
        vm.getByFilter                      = getByFilter;
        vm.mountGraphTop10CourseInterest    = mountGraphTop10CourseInterest;
        vm.activate                         = activate;
        vm.resetGraph                       = resetGraph;
        
        vm.expoSelected                     = '';
        vm.citySelected                     = '';
        vm.flag                             = false;
        vm.isPrivate                        = isPrivate;

        function selectExpos () {
            if(expos) {
                vm.expos = expos;
            } else {
                let query ={}
                query['with_stats'] = 1;
                query['order_by'] = 'DESC';
                ExpoService.getExpos(query).then(function(response) {
                    vm.expos = response.expos;
                });
            }
        }

        function selectCitiesByExpo () {
            CitiesByExpoService.getCities(vm.expoSelected).then(function(response){
                vm.cities = response.data;
                vm.cities.unshift({expos_locations_id: -1, city_name: '--- All ---'});
                vm.citySelected = -1;
            }).catch(function(err) {
            });
        }

        function getByFilter () {
            vm.flag = false;
            let query = {};
            query['expo_id'] = vm.expoSelected;
            if(vm.isPrivate) {
                query['private'] = 1;
            }
            if (vm.citySelected !== '' && vm.citySelected !== -1) {
                query['location_id'] = vm.citySelected;
            }
            vm.resetGraph();
            ExpoService.getGeneralInformation(query).then(function(response) {
                vm.flag = true;
                vm.generalInformation = response.data;
                vm.mountGraphTop10CourseInterest(vm.generalInformation.total_course_interest);
            });
        }

        function resetGraph () {
            vm.graphTop10CourseInterest         = {data: [], labels: [], colors: [], options: {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            // suggestedMin: 50,
                            // suggestedMax: 100,
                            callback: function (value) {
                                return value + '%'; // convert it to percentage
                            },
                        }
                    }],
                },
                tooltips: {
                    callbacks: {
                        label: function(t, d) {
                            return t.yLabel + '%';
                        }
                    }
                }
            }};
        }

        function activate () {
            vm.selectExpos();
            vm.resetGraph();
        }

        function mountGraphTop10CourseInterest (data) {
            angular.forEach(data, function(value, key) {
                vm.graphTop10CourseInterest.data.push(value.percent);
                vm.graphTop10CourseInterest.labels.push(value.label);
                vm.graphTop10CourseInterest.colors.push('#05a9f4');
            });
        }

        vm.activate();
    }
})();